module.exports = __webpack_public_path__ + "img/clerenet-logo.4e9ecc24.png";